import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const [info, setInfo] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.status === "paid") { setInfo(data); setState("paid"); return; }
      } catch {}
      if (++tries < 15) setTimeout(poll, 1500);
      else setState("timeout");
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md border border-border bg-card p-8 rounded-sm text-center">
        {state === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-primary mx-auto mb-4 animate-spin"/>
            <h2 className="font-display font-black text-2xl uppercase mb-2">Confirming payment</h2>
            <div className="text-sm text-muted-foreground">Hold on while Stripe processes the transaction.</div>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-4"/>
            <h2 className="font-display font-black text-3xl uppercase mb-2">Payment received</h2>
            <div className="text-sm text-muted-foreground mb-6">Your invoice has been marked as paid.</div>
            <Button data-testid="pay-success-back" onClick={() => nav("/invoices")} className="rounded-sm bg-primary text-primary-foreground uppercase tracking-[0.15em]">Back to Invoices</Button>
          </>
        )}
        {state === "timeout" && (
          <>
            <XCircle className="w-14 h-14 text-yellow-500 mx-auto mb-4"/>
            <h2 className="font-display font-black text-2xl uppercase mb-2">Still processing</h2>
            <div className="text-sm text-muted-foreground mb-6">Payment is taking longer than expected. Check invoices in a minute.</div>
            <Link to="/invoices" className="text-primary text-sm uppercase tracking-[0.15em]">Back →</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-14 h-14 text-destructive mx-auto mb-4"/>
            <h2 className="font-display font-black text-2xl uppercase">Session missing</h2>
          </>
        )}
      </div>
    </div>
  );
}
